import { render, staticRenderFns } from "./NoAccessibleWindowsWarning.vue?vue&type=template&id=48897723&"
import script from "./NoAccessibleWindowsWarning.vue?vue&type=script&lang=js&"
export * from "./NoAccessibleWindowsWarning.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports